module.exports = __webpack_public_path__ + "static/img/2020_grow_in_grace3.b9a7c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel/2020_grow_in_grace3.jpg
// module id = 2jdE
// module chunks = 1